import React, { useState, useEffect, useRef } from 'react'
import {
    Box, Tooltip, TextField
} from "@mui/material";
import PricingCopyMenu from './PricingCopyMenu'

const MaxInput = ({ day, room, season, seasonEditCopyRef, isReadOnlyMode, manageSeasonChangeFunc, discardCount, globalErrorMsg, disableDownCopy, disableRightCopy, copyInputCount, registerRef, onNavigate }) => {
    let min = null;
    let max = null;
    if (seasonEditCopyRef.current.dependent_room_type.room_type[room]) {
        min = seasonEditCopyRef.current.dependent_room_type.room_type[room][day].min;
        max = seasonEditCopyRef.current.dependent_room_type.room_type[room][day].max;
    }



    const inputRef = useRef(null);
    const [inputErrorMsg, setInputErrorMsg] = useState(false);
    const [isBaseRoomTypeChanged, setIsBaseRoomTypeChanged] = useState(season.isBaseRoomTypeChanged);

    const handleInputBlur = (event) => {
        //let min = min;
        let max = event.target.value.trim();

        // remove decimal if any
        if (max.includes('.')) {
            max = max.split('.')[0];
            event.target.value = max;
        }

        // if max has negative sign then remove it
        if (max.includes('-')) {
            max = 1;
            max = Number(max);
            event.target.value = max;
            seasonEditCopyRef.current.dependent_room_type.room_type[room][day].max = max;
            manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });
            return;
        }

        // if max is blank
        if (max === '') {
            setInputErrorMsg('This field is required.');
            seasonEditCopyRef.current.dependent_room_type.room_type[room][day].max = null;
            manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });
            return;
        }
        setIsBaseRoomTypeChanged(false);
        // if min is blank then min can be any positive number
        if (!min && min !== 0) {
            max = Number(max);
            setInputErrorMsg(false);
            seasonEditCopyRef.current.dependent_room_type.room_type[room][day].max = max;
            manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });
            return;
        }

        // if max is less than min
        min = Number(min);
        max = Number(max);
        if (max < min) {
            setInputErrorMsg('Ceiling cannot be lesser than floor.');
            seasonEditCopyRef.current.dependent_room_type.room_type[room][day].max = max;
            manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });
            return;
        }

        setInputErrorMsg(false);
        seasonEditCopyRef.current.dependent_room_type.room_type[room][day].max = max;
        manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });

    }

    useEffect(() => {
        setInputErrorMsg(false);
        inputRef.current.value = season.dependent_room_type.room_type[room]?.[day]?.max || null;
    }, [discardCount])

    useEffect(() => {
        if (seasonEditCopyRef.current.dependent_room_type.room_type[room][day].min && seasonEditCopyRef.current.dependent_room_type.room_type[room][day].max) {
            let min = seasonEditCopyRef.current.dependent_room_type.room_type[room][day].min;
            let max = seasonEditCopyRef.current.dependent_room_type.room_type[room][day].max;
            if (max < min) {
                setInputErrorMsg('Ceiling cannot be lesser than floor.');
            }
            else {
                setInputErrorMsg(false);
            }
        }
    }, [globalErrorMsg.length]);

    const handleCopyRight = () => {
        setIsBaseRoomTypeChanged(false);
        const currentValue = seasonEditCopyRef.current.dependent_room_type.room_type[room][day].max;

        const dayKeys = Object.keys(seasonEditCopyRef.current.dependent_room_type.room_type[room]);
        const currentIndex = dayKeys.indexOf(day);
        if (currentIndex === -1) return;

        // Copy value to the right-side inputs
        for (let i = currentIndex + 1; i < dayKeys.length; i++) {
            const nextDay = dayKeys[i];
            seasonEditCopyRef.current.dependent_room_type.room_type[room][nextDay].max = currentValue;

        }

        manageSeasonChangeFunc({
            action: 'copyInput',
            season: seasonEditCopyRef.current
        });
        //console.log("seasonEditCopyRef.current", seasonEditCopyRef.current)
    };

    const handleCopyDown = () => {
        const currentValue = seasonEditCopyRef.current.dependent_room_type.room_type[room][day].max;
        const allRooms = Object.keys(seasonEditCopyRef.current.dependent_room_type.room_type); //deepCopy(inventoryRoomCodes);
        const currentRoomIndex = allRooms.indexOf(room);
        if (currentRoomIndex === -1) return;

        // Copy value to the below inputs of same day 
        for (let i = currentRoomIndex + 1; i < allRooms.length; i++) {
            const nextRoom = allRooms[i];
            seasonEditCopyRef.current.dependent_room_type.room_type[nextRoom][day].max = currentValue;
        }

        manageSeasonChangeFunc({
            action: 'copyInput',
            season: seasonEditCopyRef.current,
        });
    };

    useEffect(() => {
        inputRef.current.value = seasonEditCopyRef.current.dependent_room_type.room_type[room][day].max;

        // clear the error on copied inputs if value is validated
        const minValue = seasonEditCopyRef.current.dependent_room_type.room_type[room][day].min;
        const maxValue = seasonEditCopyRef.current.dependent_room_type.room_type[room][day].max;

        if (maxValue !== null && maxValue > minValue) {
            setInputErrorMsg(false);
            setIsBaseRoomTypeChanged(false);

        }
    }, [copyInputCount]);

    // Register on every render
    registerRef("max", day, room, inputRef);

    const handleArrowKeyNavigation = (e) => {
        const navKeys = ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"];
        if (!navKeys.includes(e.key)) return;

        e.preventDefault();
        const direction = e.key.replace("Arrow", "").toLowerCase();
        onNavigate(direction, day, room, "max");
    };



    return (
        <Box className="grid-col" >
            <Tooltip
                arrow
                title={inputErrorMsg}
                placement="top"
                slotProps={{
                    tooltip: {
                        sx: {
                            maxWidth: 350,
                        },
                    },
                }}
            >
                <TextField
                    type="number"
                    inputRef={inputRef}
                    className={`custom-textfield 
                        ${inputErrorMsg ? 'error' : ''}
                        ${max === null && !season.id.includes('new_') ? 'empty_field' : ''} 
                    `}
                    size="small"
                    fullWidth
                    margin="dense"
                    disabled={isReadOnlyMode}
                    defaultValue={max}
                    onFocus={(e) => setTimeout(() => e.target.select(), 0)}
                    onBlur={(event) => { handleInputBlur(event) }}
                    onKeyDown={handleArrowKeyNavigation}
                    autoComplete="off"
                />
                {!isReadOnlyMode && max !== null && max !== undefined && (
                    <PricingCopyMenu
                        disableDownCopy={disableDownCopy}
                        disableRightCopy={disableRightCopy}
                        onCopyRight={handleCopyRight}
                        onCopyDown={handleCopyDown}
                    />
                )}
            </Tooltip>
        </Box>
    )
}

export default MaxInput